import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_TASK_DEFINITION_LIST_REQUEST = NS + 'FIND_TASK_DEFINITION_LIST_REQUEST'
export const FIND_TASK_DEFINITION_LIST_SUCCESS = NS + 'FIND_TASK_DEFINITION_LIST_SUCCESS'
export const FIND_TASK_DEFINITION_LIST_ERROR = NS + 'FIND_TASK_DEFINITION_LIST_ERROR'

export const CHANGE_TASK_DEFINITION = NS + 'CHANGE_TASK_DEFINITION'

export const SAVE_TASK_DEFINITION_REQUEST = NS + 'SAVE_TASK_DEFINITION_REQUEST'
export const SAVE_TASK_DEFINITION_SUCCESS = NS + 'SAVE_TASK_DEFINITION_SUCCESS'
export const SAVE_TASK_DEFINITION_ERROR = NS + 'SAVE_TASK_DEFINITION_ERROR'




// WEBPACK FOOTER //
// ./src/modules/process/state/task-definition/type.js